<!--
 * @Description: 
 * @Author: 樊文静
 * @LastEditors: 樊文静
 * @Date: 2021-08-05 14:44:52
 * @LastEditTime: 2021-08-19 13:52:05
-->
<template>
  <div class="remind-wrap">
    <el-form-item
      label="提醒方式"
      label-width="145px"
      :prop="`${alarmType}Info.remindModeList`"
      :rules="{
        required: true,
        message: '至少勾选一种提醒方式',
        trigger: 'change'
      }"
    >
      <el-checkbox-group
        v-model="alarmParams[alarmType + 'Info'].remindModeList"
      >
        <el-checkbox
          v-for="({ id, label }, i) in remindModeList"
          :key="`${id}-${i}`"
          :label="id"
          >{{ label }}</el-checkbox
        >
      </el-checkbox-group>
    </el-form-item>
    <div></div>
    <el-form-item
      label="提醒对象"
      label-width="145px"
      :prop="`${alarmType}Info.remindPersonList`"
      :rules="{
        required: true,
        message: '至少勾选一种提醒对象',
        trigger: 'change'
      }"
    >
      <el-checkbox-group
        class="remind-person-list"
        v-model="alarmParams[alarmType + 'Info'].remindPersonList"
      >
        <el-checkbox :label="1">报警联系人</el-checkbox>

        <el-form-item
          v-if="alarmParams[alarmType + 'Info'].remindPersonList.includes(1)"
          class="form-item"
          :prop="`${alarmType}Info.alarmContactList`"
          :rules="{
            required: true,
            message: '请选择报警联系人',
            trigger: 'change'
          }"
        >
          <e6-vr-select
            virtual
            clearable
            multiple
            placeholder="请选择报警联系人"
            :loading="contactLoad"
            v-model="alarmParams[alarmType + 'Info'].alarmContactList"
            :data="contactList"
          ></e6-vr-select>
        </el-form-item>

        <el-checkbox :label="2">联系用户</el-checkbox>
        <el-form-item
          v-if="alarmParams[alarmType + 'Info'].remindPersonList.includes(2)"
          :prop="`${alarmType}Info.userContactList`"
          :rules="{
            required: true,
            message: '请选择联系用户',
            trigger: 'change'
          }"
        >
          <e6-vr-select
            virtual
            clearable
            multiple
            placeholder="请选择联系用户"
            v-model="alarmParams[alarmType + 'Info'].userContactList"
            :data="linkManDataSource"
          ></e6-vr-select>
        </el-form-item>
      </el-checkbox-group>
    </el-form-item>
  </div>
</template>
<script>
export default {
  props: {
    //报警联系人类型("conPersonMes"预警联系人，2"levelOneConPersonMes"一级报警联系人，3"levelTwoConPersonMes"二级报警联系人，4"levelThreeConPersonMes"三级报警联系人)
    alarmType: {
      type: String,
      require: true
    },
    //运单规则参数
    alarmParams: {
      type: Object,
      default: null
    },
    //格式化之后的数据
    formatData: {
      type: Object,
      default: null
    },
    //联系人loading
    contactLoad: {
      type: Boolean,
      default: false
    },
    //报警联系人数据
    contactList: {
      type: Array,
      default: () => []
    },
    //联系用户数据
    linkManDataSource: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      remindModeList: [
        {
          id: 1,
          label: "平台提示"
        },
        {
          id: 2,
          label: "短信"
        },
        {
          id: 3,
          label: "邮件"
        },
        {
          id: 4,
          label: "微信（易流云OS）"
        }
      ]
    };
  }
};
</script>
<style lang="scss" scoped>
.remind-wrap {
  .remind-person-list {
    /deep/ .el-checkbox,
    .form-item {
      margin-right: 10px;
    }
  }
  /deep/.el-input__inner {
    text-align: left !important;
  }
}
</style>
